<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box no-display" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Excess Amount Report</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined />
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
            item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
        </v-col>

        <v-col sm="2" v-if="sel_ay_data && stud_status">
          <v-btn class="mt-6 button" @click="getReport()" :loading="fetch_loader">Fetch</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="fee_student_master_list != ''">
      <v-col cols="12" sm="12" md="12">
        <v-btn class="ma-2 no-display " rounded color="success" outlined
          @click="fnExcelReport('my-table-id', 'ExcessAmountReport')" :loading="loader"><v-icon
            color="success">mdi-export</v-icon>Export</v-btn>
      </v-col>
      <div id="my-table-id">
        <v-data-table v-if="fee_student_master_list != ''" :headers="headers1" :items="bookList1" :search="search" dense
          class="elevation-1 mytable" @current-items="getFiltered">
          <template v-slot:top class="pb-5">
            <v-row dense justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers1" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                            color="#0F2027" :label="header.text" multiple clearable
                            :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>
          <template v-slot:[`item.refund_payment_list`]="{ item }">
            <span v-for="r,index in item.refund_payment_list" :key="index">
              <v-tooltip top color="warning">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on"
                    @click="print(r)"> <v-icon color="warning">mdi-printer</v-icon>{{r.receipt_no}}</v-btn>
                </template>
                <span> Print Fee Receipt!!! </span>
              </v-tooltip>
            </span>
          </template>

        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      status_list: [],
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      stud_status: "",
      overlay: false,
      fetch_loader: false,
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      mainList: [],
      date: null,
      new_date: null,
      org_basic_data: [],
      headers1: [
        {
          text: "Sr. No.",
          value: "sr_no",
        },
        {
          text: "Student",
          align: "center",
          value: "learner",
        },
        {
          text: "Academic Year",
          align: "center",
          value: "ay",
        },
        {
          text: "Quota",
          align: "center",
          value: "quota",
        },
        {
          text: "Standard",
          align: "center",
          value: "standard",
        },
        {
          text: "Excess Amount",
          align: "center",
          value: "amount",
        },
        {
          text: "Refunded Amount",
          align: "center",
          value: "refunded_amount",
        },
        {
          text: "Refunded Amount Receipt",
          align: "center",
          value: "refund_payment_list",
        },
      ],
      fee_student_master_list: [],
      filterArr: [],
      filters: {
        standard: [],
        quota: [],
        leaner: [],
      },
      table_fields: {
        "Sr. No": "sr_no",
        Student: "leaner",
        Quota: "quota",
        "Academic Year": "ay",
        Standard: "standard",
        "Excess Amount": "amount",
      },
    };
  },
  computed: {
    bookList1() {
      return this.fee_student_master_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    print(item){
                this.$session.set("receipt_data", JSON.stringify(item));
                this.$session.set("org_basic_data", JSON.stringify(this.org_basic_data));
                let routeData = this.$router.resolve({ name: "refund-receipt-print" });
                window.open(routeData.href, "_blank");
            },
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Student</th>
      <th>Academic Year</th>
      <th>Quota</th>
      <th>Standard</th>
      <th>Excess Amount</th>
     
    </tr>`;

  this.fee_student_master_list.forEach((s, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${s.learner}</td>
        <td>${s.ay}</td>
        <td>${s.quota}</td>
        <td>${s.standard}</td>
        <td>${s.amount}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.fee_student_master_list.map((d) => d[val]);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getReport() {
      this.fee_student_master_list = [];
      this.fetch_loader = true;
      const data = {
        ay: this.sel_ay_data.ay_id,
        stud_status: this.stud_status.id,
      };
      axios
        .post("/FeesStructureInstallment/getExcessAmountReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fee_student_master_list = res.data.fee_student_master_list;
            this.org_basic_data = res.data.org_basic_data
          }
          if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {
          this.fetch_loader = false;
        });
    },
    onload() {
      axios
        .post("/commonAPI/getAyStream")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.status_list = res.data.status_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>

<style scoped>
.mytable2 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
